import React from "react";

function GoogleIcon ({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <g clipPath="url(#clip0_1065_6)">
        <path
          fill="#167EE6"
          d="M26.943 11.566H15.522a.913.913 0 00-.913.912v3.649c0 .504.409.913.913.913h6.431a8.586 8.586 0 01-3.695 4.33L21 26.119c4.4-2.544 7-7.008 7-12.005 0-.712-.052-1.22-.157-1.793a.917.917 0 00-.9-.754z"
        ></path>
        <path
          fill="#12B347"
          d="M14 22.522c-3.148 0-5.895-1.72-7.371-4.265l-4.747 2.736C4.298 25.181 8.823 28 14 28c2.54 0 4.936-.684 7-1.875v-.007l-2.742-4.747A8.458 8.458 0 0114 22.52z"
        ></path>
        <path
          fill="#0F993E"
          d="M21 26.125v-.007l-2.742-4.747A8.458 8.458 0 0114 22.52V28c2.54 0 4.936-.684 7-1.875z"
        ></path>
        <path
          fill="#FFD500"
          d="M5.478 14c0-1.551.424-3.003 1.151-4.257L1.882 7.006A13.855 13.855 0 000 14c0 2.546.684 4.936 1.882 6.994l4.747-2.737A8.458 8.458 0 015.48 14z"
        ></path>
        <path
          fill="#FF4B26"
          d="M14 5.478c2.052 0 3.938.73 5.41 1.943a.91.91 0 001.224-.055L23.22 4.78a.92.92 0 00-.052-1.346A13.958 13.958 0 0014 0C8.823 0 4.298 2.82 1.882 7.007l4.747 2.736C8.105 7.198 10.852 5.478 14 5.478z"
        ></path>
        <path
          fill="#D93F21"
          d="M19.41 7.42a.91.91 0 001.224-.054L23.22 4.78a.92.92 0 00-.052-1.346A13.958 13.958 0 0014 0v5.478c2.052 0 3.938.73 5.41 1.943z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1065_6">
          <path fill="#fff" d="M0 0H28V28H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default GoogleIcon;